import { FinalDataUploadHistory, HistoryHandlerInterface, HistoryItem } from '../../interfaces/interfaces';

const uploadHistoryAdapter = (
  items: HistoryItem[] | [],
  historyHandler: (item: HistoryItem) => HistoryHandlerInterface
): FinalDataUploadHistory[] => {
  return items?.map((i) => {
    const fn = historyHandler(i);
    return {
      id: fn.getId(),
      uploadedOn: fn.getTimeCreatedAt(),
      uploadedBy: fn.getUserName(),
      fileType: fn.getFileType(),
      fileContent: fn.getFileContent(),
      fileSource: fn.getFileSource(),
      version: fn.getFileVersion(),
      fileLastUpdated: fn.getTimeUpdatedAt(),
      fileDataUrl: fn.getFileDataUrl(),
      fileName: fn.getFileDataName(),
      uploadStatus: fn.getUploadHistoryStatus(),
    };
  });
};

export default uploadHistoryAdapter;
